














import { Prop, Component, Vue } from "vue-property-decorator";

import VStaffTable, { StaffTableItem } from "@/components/VStaffTable.vue";
import VInvite from "@/components/VInvite.vue";
import VSearchBar from "@/components/VSearchBar.vue";

@Component({
  components: {
    VInvite,
    VSearchBar,
    VStaffTable
  }
})
export default class StaffList extends Vue {
  @Prop({ default: () => [] }) items!: StaffTableItem[];
  @Prop({ type: Boolean, default: false }) noInvite!: boolean;

  select(id: number) {
    this.$emit("select", id);
  }

  invite(id: number) {
    this.$emit("invite", id);
  }

  search(query: string) {
    this.$emit("search", query);
  }
}
